module.exports = __webpack_public_path__ + "img/index-zt1.19bfc2d2.png";